import React from "react";
import PropTypes from "prop-types";
import TailwindWrapper from "../../../components/TailwindWrapper/TailwindWrapper";

/**
 * EMPProgressBar - A reusable progress bar component for displaying completion progress
 * Expects {@code progress} from dealer onboarding `/progress` as {@code progressPercent}.
 */
const EMPProgressBar = ({
  progress: progressFromProp,
  showPercentage = true,
  className = "",
}) => {
  const n = Number(progressFromProp);
  const rawProgress =
    progressFromProp != null &&
    progressFromProp !== "" &&
    !Number.isNaN(n)
      ? n
      : 0;

  const normalizedProgress = Math.min(Math.max(rawProgress, 0), 100);
  const displayPercent = Math.round(normalizedProgress);

  const getProgressBarStyle = () => ({
    width: `${normalizedProgress}%`,
    backgroundColor: "#008200",
    height: "16px",
  });

  const getProgressContainerStyle = () => ({
    border: `1px solid #B2B2B2`,
    height: "26px",
    backgroundColor: "#ffffff",
  });

  return (
    <TailwindWrapper>
      <div className={`tw-space-y-2 ${className}`}>
        {showPercentage && (
          <div className="tw-flex tw-justify-between tw-items-center">
            <span className="tw-text-lg tw-font-medium tw-text-gray-900">
              {displayPercent}% Completed
            </span>
          </div>
        )}

        <div
          className="tw-w-full tw-rounded-full tw-p-1"
          style={getProgressContainerStyle()}
        >
          <div
            className="tw-rounded-full tw-transition-all tw-duration-300 tw-ease-out"
            style={getProgressBarStyle()}
          />
        </div>
      </div>
    </TailwindWrapper>
  );
};

EMPProgressBar.propTypes = {
  /** Progress percentage (0-100), e.g. {@code progressPercent} from `/progress` */
  progress: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Whether to show percentage text */
  showPercentage: PropTypes.bool,
  /** Additional CSS classes */
  className: PropTypes.string,
};

export default EMPProgressBar;
